const fr = {
  label: '🇫🇷 French',
  ipa: {
    97: {
      ex: (
        <span>
          p<b>a</b>tte, l<b>à</b>, f<b>e</b>mme
        </span>
      ),
    },
    98: {
      ex: (
        <span>
          <b>b</b>on
        </span>
      ),
    },
    100: {
      ex: (
        <span>
          <b>d</b>eux, gran<b>d</b>e
        </span>
      ),
    },
    101: {
      ex: (
        <span>
          cl<b>é</b>, <b>et</b>, l<b>es</b>, ch<b>ez</b>, all<b>er</b>, pi
          <b>ed</b>, journ<b>é</b>e{' '}
        </span>
      ),
    },
    102: {
      ex: (
        <span>
          <b>f</b>aire, vi<b>f</b>
        </span>
      ),
    },
    105: {
      ex: (
        <span>
          f<b>i</b>n<b>i</b>, s<b>i</b>, <b>î</b>le, rég<b>ie</b>, pa<b>y</b>s,
          f<b>i</b>ls
        </span>
      ),
    },
    106: {
      ex: (
        <span>
          f<b>i</b>ef, pa<b>y</b>er, fi<b>ll</b>e, trava<b>il</b>, <b>hi</b>er
        </span>
      ),
    },
    107: {
      ex: (
        <span>
          <b>c</b>orps, ave<b>c</b>, <b>qu</b>and, Ira<b>k</b>
        </span>
      ),
    },
    108: {
      ex: (
        <span>
          <b>l</b>aisser, possib<b>l</b>e, seu<b>l</b>
        </span>
      ),
    },
    109: {
      ex: (
        <span>
          <b>m</b>ê<b>m</b>e
        </span>
      ),
    },
    110: {
      ex: (
        <span>
          <b>n</b>ous, bo<b>nn</b>e
        </span>
      ),
    },
    111: {
      ex: (
        <span>
          s<b>au</b>t, h<b>au</b>t, bur<b>eau</b>, ch<b>o</b>se, t<b>ô</b>t, c
          <b>ô</b>ne
        </span>
      ),
    },
    112: {
      ex: (
        <span>
          <b>p</b>ère
        </span>
      ),
    },
    115: {
      ex: (
        <span>
          <b>s</b>ans, <b>ç</b>a, a<b>ss</b>ez, <b>s</b>oi<b>x</b>ante, si
          <b>x</b>, di
          <b>x</b>
        </span>
      ),
    },
    116: {
      ex: (
        <span>
          <b>t</b>out, <b>t</b>hé
        </span>
      ),
    },
    117: {
      ex: (
        <span>
          c<b>ou</b>p, r<b>oue</b>
        </span>
      ),
    },
    118: {
      ex: (
        <span>
          <b>v</b>ous, <b>w</b>agon
        </span>
      ),
    },
    119: {
      ex: (
        <span>
          <b>ou</b>i, l<b>o</b>i, m<b>o</b>yen, <b>w</b>eb, <b>wh</b>isky
        </span>
      ),
    },
    121: {
      ex: (
        <span>
          t<b>u</b>, s<b>û</b>r, r<b>ue</b>
        </span>
      ),
    },
    122: {
      ex: (
        <span>
          <b>z</b>éro, rai<b>s</b>on, cho<b>s</b>e, deu<b>x</b>ième{' '}
        </span>
      ),
    },
    248: {
      ex: (
        <span>
          c<b>eu</b>x, j<b>eû</b>ner, qu<b>eue</b>
        </span>
      ),
    },
    331: {
      ex: (
        <span>
          campi<b>ng</b>, fu<b>n</b>k
        </span>
      ),
    },
    330: {
      ex: (
        <span>
          s<b>œu</b>r, j<b>eu</b>ne, cl<b>u</b>b (Europe)
        </span>
      ),
    },
    593: {
      ex: (
        <span>
          p<b>â</b>te, gl<b>a</b>s
        </span>
      ),
    },
    596: {
      ex: (
        <span>
          s<b>o</b>rt, minim<b>u</b>m, p<b>o</b>mme
        </span>
      ),
    },
    601: {
      ex: (
        <span>
          r<b>e</b>poser, m<b>on</b>sieur, f<b>ai</b>sons
        </span>
      ),
    },
    603: {
      ex: (
        <span>
          b<b>aie</b>, f<b>ai</b>te, m<b>e</b>ttre, r<b>e</b>nne, cr<b>è</b>me,
          p<b>ei</b>ne, viol<b>et</b>
        </span>
      ),
    },
    609: {
      ex: (
        <span>
          <b>g</b>arçon, lon<b>g</b>ue{' '}
        </span>
      ),
    },
    613: {
      ex: (
        <span>
          h<b>ui</b>t, P<b>uy</b>
        </span>
      ),
    },
    626: {
      ex: (
        <span>
          ga<b>gn</b>er, champa<b>gn</b>e
        </span>
      ),
    },
    641: {
      ex: (
        <span>
          <b>r</b>ega<b>r</b>der, Pa<b>r</b>is
        </span>
      ),
    },
    643: {
      ex: (
        <span>
          <b>ch</b>ose
        </span>
      ),
    },
    658: {
      ex: (
        <span>
          <b>j</b>amais, visa<b>g</b>e
        </span>
      ),
    },
    0x02520303: {
      ex: (
        <span>
          s<b>an</b>s, ch<b>am</b>p, v<b>en</b>t, t<b>em</b>ps, J<b>ean</b>, t
          <b>aon</b>
        </span>
      ),
    },
    0x025b0303: {
      ex: (
        <span>
          v<b>in</b>, <b>im</b>pair, p<b>ain</b>, d<b>aim</b>, pl<b>ein</b>, R
          <b>eim</b>s, s<b>yn</b>thèse, s<b>ym</b>pathique, bi<b>en</b>
        </span>
      ),
    },
    0x025b02d0: {
      ex: (
        <span>
          f<b>ê</b>te, m<b>aî</b>tre, r<b>ei</b>ne, r<b>eî</b>tre, c<b>ai</b>
          sse, pr<b>e</b>sse, Lev<b>es</b>que
        </span>
      ),
    },
    0x01530303: {
      ex: (
        <span>
          <b>un</b>, parf<b>um</b>
        </span>
      ),
    },
    0x02540303: {
      ex: (
        <span>
          s<b>on</b>, n<b>om</b>
        </span>
      ),
    },
    0x006403610292: {
      ex: (
        <span>
          <b>Dj</b>ibouti
        </span>
      ),
    },
    0x7403610283: {
      ex: (
        <span>
          <b>tch</b>èque
        </span>
      ),
    },
  },
};
export default fr;
